// extracted by mini-css-extract-plugin
export default {"table_wrapper":"MissingPegawai_table_wrapper__mqWR6"};